export enum UrlResolveEnum {
    Product = 'PRODUCT',
    Category = 'CATEGORY',
    CMS = 'CMS',
    Custom = 'CUSTOM'
}
